export default "__VITE_ASSET__CYZfMalr__"